import React from 'react';

function Header() {
    return (<header>Level 350 Sample Solution - React</header>);
}

export default Header;